import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar'

type Props = {
  email?: string | null
  firstName?: string | null
  fullName?: string | null
  image?: string | null
  lastName?: string | null
}

const getUserInitials = ({
  firstName,
  fullName,
  lastName,
}: Pick<Props, 'firstName' | 'fullName' | 'lastName'>) => {
  const initials = `${firstName?.[0] ?? ''}${lastName?.[0] ?? ''}`.toUpperCase()

  if (initials) {
    return initials
  }

  return (
    fullName
      ?.split(' ')
      .filter(Boolean)
      .slice(0, 2)
      .map((part) => part[0])
      .join('')
      .toUpperCase() ?? ''
  )
}

export const UserSummary = ({
  email,
  firstName,
  fullName,
  image,
  lastName,
}: Props) => {
  const userInitials = getUserInitials({ firstName, fullName, lastName })

  return (
    <div className="flex items-center gap-3 rounded-lg border bg-muted/30 px-3 py-3 text-left">
      <Avatar className="h-10 w-10 rounded-lg">
        <AvatarImage src={image ?? ''} alt={fullName ?? email ?? ''} />
        <AvatarFallback className="rounded-lg">{userInitials}</AvatarFallback>
      </Avatar>
      <div className="grid min-w-0 flex-1 text-sm leading-tight">
        <span className="truncate font-medium">
          {fullName ?? email ?? 'User'}
        </span>
        {email ? (
          <span className="text-muted-foreground truncate text-xs">
            {email}
          </span>
        ) : null}
      </div>
    </div>
  )
}
